/**
 * This file was automatically generated by ontology-generator.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSON file in
 * tools/ontology-generator/src/nodespec/relationships.json and re-run the generator.
 */
import type { PropertySchema } from './node-property-schemas'
import type { RelationshipType } from './relationships'

/**
 * Per-relationship-type edge-property schema: the keys allowed on the
 * relationship plus the subset that are required at creation time.
 * Consumed by `validateCypherWrite` to type- and enum-check inline
 * `(a)-[:R {key: value, …}]->(b)` maps and `SET r.key = value` items.
 */
export interface RelationshipPropertySchema {
  properties: Readonly<Record<string, PropertySchema>>
  required: readonly string[]
}

export const RELATIONSHIP_PROPERTY_SCHEMAS: Readonly<
  Record<RelationshipType, RelationshipPropertySchema>
> = {
  HAS_SITE: {
    properties: {},
    required: []
  },
  HAS_PROCESS: {
    properties: {},
    required: []
  },
  HAS_COMPUTE: {
    properties: {},
    required: []
  },
  HAS_SOAP_ENDPOINT: {
    properties: {},
    required: []
  },
  USES_CONTRACT: {
    properties: {},
    required: []
  },
  DECLARES_OPERATION: {
    properties: {},
    required: []
  },
  HAS_LINE: {
    properties: {},
    required: []
  },
  HAS_PRODUCTION_GOAL: {
    properties: {},
    required: []
  },
  ACCOMPLISHES: {
    properties: {},
    required: []
  },
  NETWORKS_WITH: {
    properties: {},
    required: []
  },
  HAS_SUBPROCESS: {
    properties: {},
    required: []
  },
  INSTANTIATES: {
    properties: {},
    required: []
  },
  HAS_SUBLINE: {
    properties: {},
    required: []
  },
  FEEDS: {
    properties: {},
    required: []
  },
  HAS_TAG_PROVIDER: {
    properties: {
      connection_type: {
        type: 'string',
        enum: ['remote', 'local'] as const
      }
    },
    required: []
  },
  HAS_DATABASE: {
    properties: {},
    required: []
  },
  HAS_PSS_TAG: {
    properties: {},
    required: []
  },
  HAS_EVENT_JOURNAL: {
    properties: {},
    required: []
  },
  PROVIDES: {
    properties: {},
    required: []
  },
  CONTAINS: {
    properties: {},
    required: []
  },
  CALCULATED_BY: {
    properties: {
      via_routine_urn: {
        type: 'string'
      },
      via_rung_number: {
        type: 'number'
      }
    },
    required: []
  },
  DERIVES_FROM: {
    properties: {},
    required: []
  },
  CONTAINS_TABLE: {
    properties: {},
    required: []
  },
  USES_DATABASE: {
    properties: {},
    required: []
  },
  USES_TABLE: {
    properties: {},
    required: []
  },
  HAS_EQUIPMENT: {
    properties: {},
    required: []
  },
  HAS_PART: {
    properties: {
      quantity: {
        type: 'number'
      },
      assembly_path: {
        type: 'string'
      },
      is_optional: {
        type: 'boolean'
      }
    },
    required: []
  },
  HAS_PROPERTY: {
    properties: {},
    required: []
  },
  HAS_OBSERVABLE: {
    properties: {},
    required: []
  },
  HAS_SETPOINT: {
    properties: {},
    required: []
  },
  CONNECTS_TO: {
    properties: {
      regime: {
        type: 'string',
        enum: ['discrete', 'continuous', 'batch'] as const
      }
    },
    required: []
  },
  MEASURED_BY: {
    properties: {},
    required: []
  },
  TRACKS_GOAL: {
    properties: {
      role: {
        type: 'string',
        enum: ['actual_output', 'yield'] as const
      }
    },
    required: []
  },
  TARGET_VALUE_FROM: {
    properties: {},
    required: []
  },
  SET_BY: {
    properties: {},
    required: []
  },
  STORES: {
    properties: {
      column: {
        type: 'string'
      },
      filter_column: {
        type: 'string'
      },
      filter_value: {
        type: 'string'
      },
      date_column: {
        type: 'string'
      }
    },
    required: []
  },
  MATERIALIZES: {
    properties: {},
    required: []
  },
  MERGED_WITH: {
    properties: {},
    required: []
  },
  BELONGS_TO: {
    properties: {},
    required: []
  },
  HAS_TAG: {
    properties: {},
    required: []
  },
  READS_TAG: {
    properties: {},
    required: []
  },
  WRITES_TAG: {
    properties: {},
    required: []
  },
  USES_TYPE: {
    properties: {},
    required: []
  },
  TRIGGERS: {
    properties: {
      method: {
        type: 'string'
      },
      via: {
        type: 'array',
        items: {
          type: 'string'
        }
      },
      vision_data_fields: {
        type: 'array',
        items: {
          type: 'string'
        }
      },
      jobs: {
        type: 'array',
        items: {
          type: 'string'
        }
      }
    },
    required: []
  },
  GATES: {
    properties: {},
    required: []
  },
  INHIBITS: {
    properties: {},
    required: []
  },
  CONTROLS: {
    properties: {},
    required: []
  },
  COORDINATES: {
    properties: {},
    required: []
  },
  HAS_PATTERN: {
    properties: {},
    required: []
  },
  HAS_FLOW: {
    properties: {},
    required: []
  },
  SAFETY_CRITICAL: {
    properties: {},
    required: []
  },
  RELATES_TO: {
    properties: {},
    required: []
  },
  HAS_MEMBER: {
    properties: {},
    required: []
  },
  INSTANCE_OF: {
    properties: {},
    required: []
  },
  HAS_COMPONENT: {
    properties: {},
    required: []
  },
  BINDS_TO: {
    properties: {
      binding_type: {
        type: 'string'
      },
      tag_path: {
        type: 'string'
      },
      bidirectional: {
        type: 'boolean'
      }
    },
    required: []
  },
  INHERITS_FROM: {
    properties: {},
    required: []
  },
  CALLS_FUNCTION: {
    properties: {},
    required: []
  },
  USES_QUERY: {
    properties: {},
    required: []
  },
  HAS_EVENT_SCRIPT: {
    properties: {},
    required: []
  },
  VISUALIZES: {
    properties: {},
    required: []
  },
  REFERENCES: {
    properties: {},
    required: []
  },
  MAPS_TO_TAG: {
    properties: {
      tag_path: {
        type: 'string'
      },
      mapping_method: {
        type: 'string'
      },
      confidence: {
        type: 'number'
      },
      needs_review: {
        type: 'boolean'
      },
      join_key: {
        type: 'string'
      }
    },
    required: []
  },
  MAPS_TO_CONTROL_TAG: {
    properties: {
      mapping_method: {
        type: 'string'
      },
      confidence: {
        type: 'number'
      },
      needs_review: {
        type: 'boolean'
      },
      join_key: {
        type: 'string'
      }
    },
    required: []
  },
  MAPS_TO_TYPE: {
    properties: {
      confidence: {
        type: 'number'
      },
      rationale: {
        type: 'string'
      },
      source_kind: {
        type: 'string'
      }
    },
    required: []
  },
  OF_TYPE: {
    properties: {},
    required: []
  },
  EXHIBITS_SYMPTOM: {
    properties: {
      status: {
        type: 'string',
        enum: ['documented', 'monitored', 'observed'] as const
      },
      source: {
        type: 'string'
      },
      llm_model: {
        type: 'string'
      },
      llm_confidence: {
        type: 'number'
      },
      llm_reasoning: {
        type: 'string'
      },
      authored_at: {
        type: 'string'
      },
      first_observed_at: {
        type: 'string'
      },
      last_observed_at: {
        type: 'string'
      }
    },
    required: []
  },
  CAN_OBSERVE: {
    properties: {
      latency_s: {
        type: 'number'
      },
      modalities: {
        type: 'array',
        items: {
          type: 'string',
          enum: ['visual', 'thermal', 'acoustic', 'tactile'] as const
        }
      },
      auto_interpret: {
        type: 'boolean'
      },
      pointer: {
        type: 'string'
      },
      can_see: {
        type: 'array',
        items: {
          type: 'string'
        }
      },
      last_sighted_at: {
        type: 'string'
      }
    },
    required: []
  },
  INDICATES: {
    properties: {
      display: {
        type: 'string',
        enum: ['needle', 'digital', 'sight_glass', 'lamp'] as const
      },
      range_low: {
        type: 'number'
      },
      range_high: {
        type: 'number'
      },
      source: {
        type: 'string'
      }
    },
    required: []
  },
  INDUCES: {
    properties: {},
    required: []
  },
  CAUSED_BY: {
    properties: {
      status: {
        type: 'string',
        enum: ['confirmed', 'rejected'] as const
      },
      confidence: {
        type: 'number'
      },
      run_id: {
        type: 'string'
      },
      reviewed_by: {
        type: 'string'
      }
    },
    required: []
  },
  HAS_INTENT: {
    properties: {},
    required: []
  },
  HAS_PHRASE: {
    properties: {},
    required: []
  },
  USES_EQUIPMENT: {
    properties: {
      usage_kind: {
        type: 'string',
        enum: [
          'source',
          'destination',
          'tool',
          'fixture',
          'processor',
          'inspection',
          'other'
        ] as const
      }
    },
    required: []
  },
  RAN_ON: {
    properties: {},
    required: []
  },
  FOR_PRODUCT: {
    properties: {},
    required: []
  },
  FULFILLED_BY: {
    properties: {},
    required: []
  },
  LOCATED_IN: {
    properties: {},
    required: []
  },
  BATCH_OF: {
    properties: {},
    required: []
  },
  PRODUCES: {
    properties: {},
    required: []
  },
  HAS_OPERATION: {
    properties: {},
    required: []
  },
  EXECUTED_ON: {
    properties: {},
    required: []
  },
  AFFECTS_BATCH: {
    properties: {},
    required: []
  },
  OCCURRED_ON: {
    properties: {},
    required: []
  },
  HAS_QUALITY_RESULT: {
    properties: {},
    required: []
  },
  PART_OF: {
    properties: {},
    required: []
  },
  CONSUMES: {
    properties: {},
    required: []
  },
  AFFECTS: {
    properties: {},
    required: []
  },
  RELATED_TO: {
    properties: {},
    required: []
  },
  PROCEDURE_FOR: {
    properties: {},
    required: []
  },
  APPLIES_TO_PRODUCT: {
    properties: {},
    required: []
  },
  REQUIRES_PART: {
    properties: {
      quantity: {
        type: 'number'
      },
      is_optional: {
        type: 'boolean'
      }
    },
    required: []
  },
  REQUIRES_SKILL_LEVEL: {
    properties: {
      min_grade: {
        type: 'number'
      },
      max_grade: {
        type: 'number'
      }
    },
    required: []
  },
  SUPPLIED_BY: {
    properties: {},
    required: []
  },
  MANUFACTURED_BY: {
    properties: {},
    required: []
  },
  HAS_UTILITY: {
    properties: {},
    required: []
  },
  REQUIRES_UTILITY: {
    properties: {
      voltage_v: {
        type: 'number'
      },
      phase: {
        type: 'number'
      },
      fla_amps: {
        type: 'number'
      },
      hp: {
        type: 'number'
      },
      kw: {
        type: 'number'
      },
      mcc_bucket_id: {
        type: 'string'
      },
      parent_utility_node_id: {
        type: 'string'
      },
      basis_date: {
        type: 'string'
      },
      basis_status: {
        type: 'string',
        enum: ['estimated', 'vendor_spec', 'field_measured', 'nameplate'] as const
      },
      notes: {
        type: 'string'
      }
    },
    required: []
  },
  MAPS_TO_CONTROLLER: {
    properties: {},
    required: []
  },
  CONTROLLED_BY: {
    properties: {},
    required: []
  },
  COMPOSES: {
    properties: {},
    required: []
  },
  MONITORED_BY: {
    properties: {},
    required: []
  },
  HAS_ALARM: {
    properties: {},
    required: []
  },
  HAS_ALARM_DEFINITION: {
    properties: {},
    required: []
  },
  HOSTS: {
    properties: {},
    required: []
  },
  SUPERVISES: {
    properties: {
      role: {
        type: 'string',
        enum: ['master', 'slave', 'line_tracking'] as const
      },
      network_path: {
        type: 'string'
      }
    },
    required: []
  },
  HAS_JOB: {
    properties: {},
    required: []
  },
  CALLS_JOB: {
    properties: {
      instruction: {
        type: 'string'
      },
      line: {
        type: 'number'
      },
      opcode: {
        type: 'string'
      }
    },
    required: []
  },
  READ_BY: {
    properties: {
      instruction: {
        type: 'string'
      },
      line: {
        type: 'number'
      },
      opcode: {
        type: 'string'
      }
    },
    required: []
  },
  WRITTEN_BY: {
    properties: {
      instruction: {
        type: 'string'
      },
      line: {
        type: 'number'
      },
      opcode: {
        type: 'string'
      }
    },
    required: []
  },
  USED_BY: {
    properties: {
      instruction: {
        type: 'string'
      },
      line: {
        type: 'number'
      },
      opcode: {
        type: 'string'
      }
    },
    required: []
  },
  DEFINES: {
    properties: {},
    required: []
  },
  OUTPUTS_TO: {
    properties: {
      method: {
        type: 'string'
      },
      result_kinds: {
        type: 'array',
        items: {
          type: 'string'
        }
      },
      via: {
        type: 'array',
        items: {
          type: 'string'
        }
      },
      jobs: {
        type: 'array',
        items: {
          type: 'string'
        }
      },
      vision_data_fields: {
        type: 'array',
        items: {
          type: 'string'
        }
      }
    },
    required: []
  },
  USES_VISION_DATA: {
    properties: {
      method: {
        type: 'string'
      },
      confidence: {
        type: 'number'
      },
      needs_review: {
        type: 'boolean'
      }
    },
    required: []
  },
  MAPS_TO_ROBOT_SIGNAL: {
    properties: {
      method: {
        type: 'string'
      },
      confidence: {
        type: 'number'
      },
      register: {
        type: 'string'
      },
      direction: {
        type: 'string'
      }
    },
    required: []
  },
  HAS_IO_TAG: {
    properties: {
      connection: {
        type: 'string'
      },
      match_method: {
        type: 'string'
      }
    },
    required: []
  },
  REQUIRES_LABOR: {
    properties: {
      num_employees: {
        type: 'number'
      }
    },
    required: []
  },
  HAS_LINE_OPERATION: {
    properties: {},
    required: []
  },
  RECOVERS: {
    properties: {},
    required: []
  },
  FALLBACK_FOR: {
    properties: {},
    required: []
  },
  HAS_CREW_REQUIREMENT: {
    properties: {},
    required: []
  },
  COVERS: {
    properties: {},
    required: []
  },
  STAFFED_BY: {
    properties: {
      min_grade: {
        type: 'number'
      },
      max_grade: {
        type: 'number'
      }
    },
    required: []
  },
  SCHEDULED_BY: {
    properties: {},
    required: []
  },
  TRIGGERED_BY: {
    properties: {
      condition_json: {
        type: 'string'
      }
    },
    required: []
  },
  ASSIGNED_TO: {
    properties: {},
    required: []
  },
  MOUNTED_ON: {
    properties: {},
    required: []
  },
  WIRED_TO: {
    properties: {
      from_param: {
        type: 'string'
      },
      to_param: {
        type: 'string'
      },
      from_index: {
        type: 'number'
      },
      to_index: {
        type: 'number'
      },
      conn_id: {
        type: 'number'
      }
    },
    required: []
  },
  SIGNAL_FLOWS_TO: {
    properties: {
      from_param: {
        type: 'string'
      },
      to_param: {
        type: 'string'
      },
      from_index: {
        type: 'number'
      },
      to_index: {
        type: 'number'
      },
      connection_type: {
        type: 'string'
      },
      conn_id: {
        type: 'number'
      },
      assoc_conn_id: {
        type: 'number'
      },
      role: {
        type: 'string',
        enum: ['data', 'peer', 'associated', 'back_calculation'] as const
      },
      backcalc_from_param: {
        type: 'string'
      },
      backcalc_to_param: {
        type: 'string'
      }
    },
    required: []
  },
  EXPOSES: {
    properties: {},
    required: []
  },
  PARENT_OF: {
    properties: {},
    required: []
  },
  DERIVED_FROM: {
    properties: {},
    required: []
  },
  HAS_PARAM_GROUP: {
    properties: {},
    required: []
  },
  PARTNER_OF: {
    properties: {},
    required: []
  },
  SENSED_BY: {
    properties: {
      group: {
        type: 'string'
      },
      voting: {
        type: 'string'
      },
      voting_type: {
        type: 'string'
      },
      fail_direction: {
        type: 'string'
      },
      test_interval: {
        type: 'string'
      },
      proof_test_coverage: {
        type: 'string'
      },
      mttr_hours: {
        type: 'string'
      },
      trip_setpoint: {
        type: 'string'
      },
      range: {
        type: 'string'
      },
      sensor_type: {
        type: 'string'
      },
      clean_service: {
        type: 'string'
      },
      signal_comparison: {
        type: 'string'
      },
      alarm_range: {
        type: 'string'
      },
      diagnostic_filtering: {
        type: 'string'
      },
      service: {
        type: 'string'
      },
      equipment_leg: {
        type: 'string'
      },
      process_connection: {
        type: 'string'
      },
      plc_range_detect: {
        type: 'string'
      },
      plc_alarm_filter: {
        type: 'string'
      },
      plc_alarm_as_trip: {
        type: 'string'
      },
      test_mode: {
        type: 'string'
      }
    },
    required: []
  },
  ACTUATES: {
    properties: {
      group: {
        type: 'string'
      },
      voting: {
        type: 'string'
      },
      voting_type: {
        type: 'string'
      },
      action: {
        type: 'string'
      },
      stroke: {
        type: 'string'
      },
      test_interval: {
        type: 'string'
      },
      pst_interval: {
        type: 'string'
      },
      proof_test_coverage: {
        type: 'string'
      },
      mttr_hours: {
        type: 'string'
      },
      fail_design: {
        type: 'string'
      },
      tso: {
        type: 'string'
      },
      clean_service: {
        type: 'string'
      },
      partial_stroke_test: {
        type: 'string'
      },
      service: {
        type: 'string'
      },
      protected_equipment: {
        type: 'string'
      },
      test_mode: {
        type: 'string'
      }
    },
    required: []
  },
  PROTECTS: {
    properties: {},
    required: []
  },
  SOLVED_BY: {
    properties: {},
    required: []
  },
  HAS_PROTECTIVE_FUNCTION: {
    properties: {},
    required: []
  },
  IN_SECTION: {
    properties: {},
    required: []
  },
  CITES: {
    properties: {},
    required: []
  },
  FOR_SCENARIO: {
    properties: {},
    required: []
  },
  HAS_ACTUATOR: {
    properties: {},
    required: []
  },
  ASSOCIATED_WITH: {
    properties: {},
    required: []
  },
  IMPLEMENTED_BY: {
    properties: {},
    required: []
  },
  MAPS_TO_SAFETY_POINT: {
    properties: {},
    required: []
  },
  APPLIES_TO: {
    properties: {
      evidence_refs: {
        type: 'array',
        items: {
          type: 'string'
        }
      }
    },
    required: []
  },
  HAS_SYMPTOM: {
    properties: {
      evidence_refs: {
        type: 'array',
        items: {
          type: 'string'
        }
      }
    },
    required: []
  },
  MAY_BE_CAUSED_BY: {
    properties: {
      evidence_refs: {
        type: 'array',
        items: {
          type: 'string'
        }
      }
    },
    required: []
  }
}
